export default __webpack_public_path__ + "images/assets/bafb83a6280c567bdcfa53d675959546.svg";